export const routerLaporan = [
  {
    path: '/laporan',
    meta: { title: 'Laporan' },
    component: () => import('@/views/laporan/index.vue'),
  },
  {
    path: '/laporan/kelola-laporan',
    meta: { title: 'Kelola Laporan' },
    component: () => import('@/views/laporan/kelola-laporan/index.vue'),
  },
  {
    path: '/laporan/lihat-pemetaan-gudang',
    meta: { title: 'Lihat Pemetaan Gudang' },
    component: () => import('@/views/laporan/lihat-pemetaan-gudang/index.vue'),
  },
  {
    path: '/laporan/laporan-penjualan',
    meta: { title: 'Laporan Penjualan' },
    component: () => import('@/views/laporan/laporan-penjualan/index.vue'),
  },
  {
    path: '/laporan/transaksi-distributor',
    meta: { title: 'Transaksi Distributor' },
    component: () => import('@/views/laporan/transaksi-distributor/index.vue'),
  },
  {
    path: '/laporan/transaksi-gudang',
    meta: { title: 'Transaksi Gudang' },
    component: () => import('@/views/laporan/transaksi-gudang/index.vue'),
  },
  {
    path: '/laporan/performance-brand',
    meta: { title: 'Performance Brand' },
    component: () => import('@/views/laporan/performance-brand/index.vue'),
  },
  {
    path: '/laporan/transaksi-toko',
    meta: { title: 'Laporan Transaksi Bulanan ID Toko' },
    component: () => import('@/views/laporan/transaksi-toko/index.vue'),
  },
  {
    path: '/laporan/konfigurasi-loyalti',
    meta: { title: 'Konfigurasi Loyalti' },
    component: () => import('@/views/laporan/konfigurasi-loyalti/index.vue'),
  },
  {
    path: '/laporan/gpm-per-gudang',
    meta: { title: 'GPM per Gudang' },
    component: () => import('@/views/laporan/gpm-per-gudang/index.vue'),
  },
  {
    path: '/laporan/gpm-per-distributor',
    meta: { title: 'GPM per Distributor' },
    component: () => import('@/views/laporan/gpm-per-distributor/index.vue'),
  },
  {
    path: '/laporan/gpm-per-produk',
    meta: { title: 'GPM per Produk' },
    component: () => import('@/views/laporan/gpm-per-produk/index.vue'),
  },
  {
    path: '/laporan/performance-gudang',
    meta: { title: 'Performance Gudang' },
    component: () => import('@/views/laporan/performance-gudang/index.vue'),
  },
  {
    path: '/laporan/laporan-loyalti-poin',
    meta: { title: 'Laporan Loyalti Poin' },
    component: () => import('@/views/laporan/laporan-loyalti-poin/index.vue'),
  },
  {
    path: '/laporan/laporan-transaksi-toko-harian',
    meta: { title: 'Laporan Transaksi ID Toko' },
    component: () => import('@/views/laporan/laporan-transaksi-toko-harian/index.vue'),
  },
  {
    path: '/laporan/laporan-kontrak-volume',
    meta: { title: 'Laporan Kontrak Volume' },
    component: () => import('@/views/laporan/laporan-kontrak-volume/index.vue'),
  },
  {
    path: '/laporan/numerik-distribution',
    meta: { title: 'Numerik Distribution' },
    component: () => import('@/views/laporan/numerik-distribution/index.vue'),
  },
  {
    path: '/laporan/unggah-program-loyalti',
    meta: { title: 'Unggah Program Loyalti' },
    component: () => import('@/views/laporan/unggah-program-loyalti/index.vue'),
  },
  {
    path: '/laporan/program-up-front',
    meta: { title: 'Program Up Front' },
    component: () => import('@/views/laporan/program-up-front/index.vue'),
  },
  {
    path: '/laporan/transaksi-distributor-2',
    meta: { title: 'Transaksi Distributor 2' },
    component: () => import('@/views/laporan/transaksi-distributor-2/index.vue'),
  },
  {
    path: '/laporan/konfigurasi-program-loyalti',
    meta: { title: 'Konfigurasi Program Loyalti' },
    component: () => import('@/views/laporan/konfigurasi-program-loyalti/index.vue'),
  },
  {
    path: '/laporan/laporan-up-front',
    meta: { title: 'Laporan Up Front' },
    component: () => import('@/views/laporan/laporan-up-front/index.vue'),
  },
  {
    path: '/laporan/laporan-toko-aktif-ca',
    meta: { title: 'Laporan Toko Aktif (CA)' },
    component: () => import('@/views/laporan/penjualan/list-toko-aktif/index.vue'),
  },
  {
    path: '/laporan/laporan-transaksi-toko',
    meta: { title: 'Laporan Transaksi Bulanan ID Toko' },
    component: () => import('@/views/laporan/laporan-transaksi-toko/index.vue'),
  },
  {
    path: '/laporan/monitor-transaksi-toko',
    meta: { title: 'Monitor Transaksi Toko' },
    component: () => import('@/views/laporan/monitor-transaksi-toko/index.vue'),
  },
  {
    path: '/laporan/laporan-detail-transaksi-gudang-distributor',
    meta: { title: 'Laporan Detail Transaksi Gudang Distributor' },
    component: () => import('@/views/laporan/laporan-detail-transaksi-gudang-distributor/index.vue'),
  },
  {
    path: '/laporan/laporan-transaksi-distributor',
    meta: { title: 'Laporan Transaksi Distributor' },
    component: () => import('@/views/laporan/laporan-transaksi-distributor/index.vue'),
  },
  {
    path: '/laporan/laporan-stok-distributor',
    meta: { title: 'Laporan Stok Distributor' },
    component: () => import('@/views/laporan/laporan-stok-distributor/index.vue'),
  },
  {
    path: '/laporan/monitor-volume-distributor',
    meta: { title: 'Monitor Volume Distributor' },
    component: () => import('@/views/laporan/monitor-volume-distributor/index.vue'),
  },
  {
    path: '/laporan/data-toko-noo',
    meta: { title: 'Data Toko Noo' },
    component: () => import('@/views/laporan/penjualan/data-toko-noo/index.vue'),
  },
  {
    path: '/laporan/data-toko-noo-new',
    meta: { title: 'Data Toko Noo New' },
    component: () => import('@/views/laporan/penjualan/data-toko-noo-new/index.vue'),
  },
  {
    path: '/laporan/laporan-transaksi-per-brand',
    meta: { title: 'Laporan Grafik Per-Brand' },
    component: () => import('@/views/laporan/laporan-transaksi-per-brand/index.vue'),
  },
  {
    path: '/laporan/laporan-transaksi-harian-gudang',
    meta: { title: 'Laporan Grafik Harian Gudang' },
    component: () => import('@/views/laporan/laporan-transaksi-harian-gudang/index.vue'),
  },
  {
    path: '/laporan/log-data-msc',
    meta: { title: 'Log Data MSC' },
    component: () => import('@/views/laporan/log-data-msc/index.vue'),
  },
  {
    path: '/laporan/master-data-toko',
    meta: { title: 'Master Data Toko' },
    component: () => import('@/views/laporan/master-data-toko/index.vue'),
  },
  {
    path: '/laporan/grafik-gudang',
    meta: { title: 'Grafik Gudang' },
    component: () => import('@/views/laporan/grafik-gudang/index.vue'),
  },
  {
    path: '/laporan/monitoring-sidigi-mdxl',
    meta: { title: 'Monitoring Sidigi MDXL' },
    component: () => import('@/views/laporan/monitoring-sidigi-mdxl/index.vue'),
  },
  {
    path: '/laporan/monitor-transaksi-toko-harian',
    meta: { title: 'Monitor Transaksi Toko Harian' },
    component: () => import('@/views/laporan/monitor-transaksi-toko-harian/index.vue'),
  },
  {
    path: '/laporan/monitor-gudang-distributor',
    meta: { title: 'Monitor Gudang Distributor' },
    component: () => import('@/views/laporan/monitor-gudang-distributor/index.vue'),
  },
  {
    path: '/laporan/level-stock',
    meta: { title: 'Potensi Penjualan Detail' },
    component: () => import('@/views/laporan/level-stock/index.vue'),
  },
  {
    path: '/laporan/potensi-penjualan-distrik-distributor',
    meta: { title: 'Potensi Penjualan Per Distrik & Distributor' },
    component: () => import('@/views/laporan/potensi-penjualan-distrik-distributor/index.vue'),
  },
  {
    path: '/laporan/potensi-penjualan-per-distrik',
    meta: { title: 'Potensi Penjualan Per Distrik' },
    component: () => import('@/views/laporan/potensi-penjualan-per-distrik/index.vue'),
  },
  {
    path: '/laporan/potensi-penjualan-per-distributor',
    meta: { title: 'Potensi Penjualan Per Distributor' },
    component: () => import('@/views/laporan/potensi-penjualan-per-distributor/index.vue'),
  },
  {
    path: '/laporan/laporan-detail-transaksi-toko',
    meta: { title: 'Laporan Detail Transaksi Toko' },
    component: () => import('@/views/laporan/laporan-detail-transaksi-toko/index.vue'),
  },
  {
    path: '/laporan/laporan-detail-transaksi-toko-v2',
    meta: { title: 'Laporan Detail Transaksi Toko V2' },
    component: () => import('@/views/laporan/laporan-detail-transaksi-toko-v2/index.vue'),
  },
  {
    path: '/laporan/laporan-detail-transaksi-toko-v3',
    meta: { title: 'Laporan Detail Transaksi Toko V3' },
    component: () => import('@/views/laporan/laporan-detail-transaksi-toko-v3/index.vue'),
  },
  {
    path: '/laporan/laporan-transaksi-harian-aksestoko',
    meta: { title: 'Laporan Transaksi Harian Aksestoko' },
    component: () => import('@/views/laporan/laporan-transaksi-harian-aksestoko/index.vue'),
  },
  {
    path: '/laporan/laporan-detail-transaksi-lt',
    meta: { title: 'Laporan Detail Transaksi LT' },
    component: () => import('@/views/laporan/laporan-detail-transaksi-lt/index.vue'),
  },
  {
    path: '/laporan/laporan-detail-transaksi-distributor',
    meta: { title: 'Laporan Detail Transaksi Distributor' },
    component: () => import('@/views/laporan/laporan-detail-transaksi-distributor/index.vue'),
  },
  {
    path: '/laporan/potensi-penjualan-detail',
    meta: { title: 'Potensi Penjualan Detail' },
    component: () => import('@/views/laporan/potensi-penjualan-detail/index.vue'),
  },
  {
    path: '/laporan/gpm-per-distrik',
    meta: { title: 'GPM Perdistrik' },
    component: () => import('@/views/laporan/gpm-per-distrik/index.vue'),
  },
  {
    path: '/laporan/laporan-cluster-toko',
    meta: { title: 'Laporan Cluster Toko' },
    component: () => import('@/views/laporan/laporan-cluster-toko/index.vue'),
  },
  {
    path: '/laporan/detail-transaksi-toko-by-product',
    meta: { title: 'Laporan Detail Transaksi Toko by Product' },
    component: () => import('@/views/laporan/detail-transaksi-toko-by-product/index.vue'),
  },
  {
    path: '/laporan/laporan-id-toko-by-product-distributor',
    meta: { title: 'Laporan ID Transaksi Toko by Product Distributor' },
    component: () => import('@/views/laporan/laporan-id-toko-by-product-distributor/index.vue'),
  },
  {
    path: '/laporan/syncron-sdfc',
    meta: { title: 'Syncron SDFC' },
    component: () => import('@/views/laporan/syncron-sdfc/index.vue'),
  },
  {
    path: '/laporan/laporan-toko-lelang-mapping',
    meta: { title: 'Laporan Suggesion Toko Lelang (Mapping Distributor)' },
    component: () => import('@/views/laporan/laporan-toko-lelang-mapping/index.vue'),
  },
  {
    path: '/laporan/laporan-toko-lelang-lintas-mapping',
    meta: { title: 'Laporan Suggession Toko Lelang (Mapping dan non Mapping Distributor)' },
    component: () => import('@/views/laporan/laporan-toko-lelang-lintas-mapping/index.vue'),
  },
  {
    path: '/laporan/laporan-toko-lelang-non-mapping',
    meta: { title: 'Laporan Suggesion Toko Lelang (Non Mapping Distributor)' },
    component: () => import('@/views/laporan/laporan-toko-lelang-non-mapping/index.vue'),
  },
  {
    path: '/laporan/laporan-suggestion-toko-lelang',
    meta: { title: 'Suggesion Toko Lelang' },
    component: () => import('@/views/laporan/laporan-suggestion-toko-lelang/index.vue'),
  },
  {
    path: '/laporan/laporan-toko-lelang',
    meta: { title: 'Laporan Toko Lelang' },
    component: () => import('@/views/laporan/laporan-toko-lelang/index.vue'),
  },
  {
    path: '/laporan/history-toko-lelang',
    meta: { title: 'History Toko Lelang' },
    component: () => import('@/views/laporan/history-toko-lelang/index.vue'),
  },
  {
    path: '/laporan/monitoring-toko-transaksi',
    meta: { title: 'Monitoring Toko Transaksi' },
    component: () => import('@/views/laporan/penjualan/monitoring-toko-transaksi/index.vue'),
  },
  {
    path: '/laporan/laporan-toko-aktif-ca-admin',
    meta: { title: 'Laporan Toko Aktif (CA) (Admin)' },
    component: () => import('@/views/laporan/penjualan/list-toko-aktif-admin.vue'),
  },
  {
    path: '/laporan/laporan-toko-aktif-lt',
    meta: { title: 'Laporan Toko Aktif LT' },
    component: () => import('@/views/laporan/penjualan/toko-aktif-lt/index.vue'),
  },
  {
    path: '/laporan/monitor-toko-belum-transaksi',
    meta: { title: 'Monitor Toko Belum Transaksi' },
    component: () => import('@/views/laporan/penjualan/monitor-toko-belum-transaksi/index.vue'),
  },
  {
    path: '/laporan-tim-io/log-stok-gudang-distributor',
    meta: { title: 'Log Stok Gudang Distributor' },
    component: () => import('@/views/laporan-tim-io/log-stok-gudang-distributor/index.vue'),
  },
  {
    path: '/laporan-aksestoko/all-transaksi',
    meta: { title: 'Laporan All Transaksi' },
    component: () => import('@/views/laporan-aksestoko/all-transaksi.vue'),
  },
  {
    path: '/laporan/penjualan/data-gudang-area',
    meta: { title: 'Data Gudang Per Area' },
    component: () => import('@/views/laporan/penjualan/data-gudang-per-area.vue'),
  },
  {
    path: '/laporan-aksestoko/register-aksestoko',
    meta: { title: 'Laporan Registrasi Aksestoko' },
    component: () => import('@/views/laporan-aksestoko/register-aksestoko.vue'),
  },
  {
    path: '/laporan/audit-trail',
    meta: { title: 'Audit Trail' },
    component: () => import('@/views/laporan/audit-trail/index.vue'),
  },
  {
    path: '/laporan-aksestoko/register-aksestoko',
    meta: { title: 'Laporan Registrasi Aksestoko' },
    component: () => import('@/views/laporan-aksestoko/register-aksestoko.vue'),
  },
]
